module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-open_new-grey-34a0327d.svg";